import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import eligibilityService from './eligibilityService';

const initialState = {
  isLoading: false,
  error: null,
  eligibiltyStep: 1,
  dealerType: "employee",
  stage: "",
  subStage: "",
  data: [],
  kycLink: "",
  addOnData: [],
  selectedAddOns: [],
  productDetailsData: null,
  eligibilityLeads: {}
};

export const kycStatusCheck = createAsyncThunk(
  "eligibility/kycStatusCheck",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.kycStatusCheck(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const productFetch = createAsyncThunk(
  "eligibility/productFetch",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.productFetch(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const productCategoryFetch = createAsyncThunk(
  "eligibility/productCategoryFetch",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.productFetch(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const productVariantFetch = createAsyncThunk(
  "eligibility/productVariantFetch",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.productFetch(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const productSearchVariantFetch = createAsyncThunk(
  "eligibility/productSearchVariantFetch",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.productFetch(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const productSubmit = createAsyncThunk(
  "eligibility/productSubmit",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.productSubmit(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const skuSubmit = createAsyncThunk(
  "eligibility/skuSubmit",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.skuSubmit(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const selectedScheme = createAsyncThunk(
  "eligibility/selectedScheme",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.selectedScheme(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const dealerSelfie = createAsyncThunk(
  "eligibility/dealerSelfie",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.dealerSelfie(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const kycLink = createAsyncThunk(
  "eligibility/kycLink",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.kycLink(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const getApplicationData = createAsyncThunk(
  "dashboard/getApplicationData",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.getApplicationData(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const sendMandateLink = createAsyncThunk(
  "dashboard/sendMandateLink",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.sendMandateLink(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const checkmandateStatus = createAsyncThunk(
  "dashboard/checkmandateStatus",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.checkmandateStatus(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const documentGenerate = createAsyncThunk(
  "eligibility/documentGenerate",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.documentGenerate(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const imeiValidation = createAsyncThunk(
  "eligibility/imeiValidation",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.imeiValidation(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const productDetails = createAsyncThunk(
  "eligibility/productDetails",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.productDetails(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const updateImeiDetails = createAsyncThunk(
  "eligibility/updateImeiDetails",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.updateImeiDetails(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const getImeiDetails = createAsyncThunk(
  "eligibility/getImeiDetails",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.getImeiDetails(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const emiDetails = createAsyncThunk(
  "eligibility/emiDetails",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.emiDetails(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const documentCallback = createAsyncThunk(
  "eligibility/documentCallback",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.documentCallback(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const addOnDetails = createAsyncThunk(
  "eligibility/addOnDetails",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.addOnDetails(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const addOnSubmit = createAsyncThunk(
  "eligibility/addOnSubmit",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.addOnSubmit(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const invoiceSubmit = createAsyncThunk(
  "eligibility/invoiceSubmit",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.invoiceSubmit(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const stageSubmit = createAsyncThunk(
  "eligibility/stageSubmit",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.stageSubmit(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const checkIfscCode = createAsyncThunk(
  "eligibility/checkIfscCode",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.checkIfscCode(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const panOcr = createAsyncThunk(
  "eligibility/panOcr",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.panOcr(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const sendMail = createAsyncThunk(
  "eligibility/sendMail",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.sendMail(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const emiProductFetch = createAsyncThunk(
  "eligibility/emiProductFetch",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.emiProductFetch(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const emiSkuSubmit = createAsyncThunk(
  "eligibility/emiSkuSubmit",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.emiSkuSubmit(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

// Add this new async thunk after the existing ones
export const calculateEMIData = createAsyncThunk(
  "eligibility/calculateEMIData",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.emiCalculation(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const caseConfirmation = createAsyncThunk(
  "eligibility/caseConfirmation",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.caseConfirmation(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const anmolCheck = createAsyncThunk(
  "eligibility/anmolCheck",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.anmolCheck(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const etbSummary = createAsyncThunk(
  "eligibility/etbSummary",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.etbSummary(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const verifyEsignOtp = createAsyncThunk(
  "eligibility/verifyEsignOtp",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.verifyEsignOtp(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const etbCheck = createAsyncThunk(
  "eligibility/etbCheck",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.etbCheck(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const mandateCheck = createAsyncThunk(
  "eligibility/mandateCheck",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.mandateCheck(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const editedKycSubmit = createAsyncThunk(
  "eligibility/editedKycSubmit",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.editedKycSubmit(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const sendEmailOtp = createAsyncThunk(
  "eligibility/sendEmailOtp",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.sendEmailOtp(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const verifyEmailOtp = createAsyncThunk(
  "eligibility/verifyEmailOtp",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.verifyEmailOtp(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const sendMobileOtp = createAsyncThunk(
  "eligibility/sendMobileOtp",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.sendMobileOtp(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const verifyMobileOtp = createAsyncThunk(
  "eligibility/verifyMobileOtp",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.verifyMobileOtp(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const employerSearch = createAsyncThunk(
  "eligibility/employerSearch",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.employerSearch(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const pincodeSearch = createAsyncThunk(
  "eligibility/pincodeSearch",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.pincodeSearch(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const getBankIfsc = createAsyncThunk(
  "eligibility/getBankIfsc",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.getBankIfsc(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const caseSearch = createAsyncThunk(
  "eligibility/caseSearch",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.caseSearch(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const dealerCheck = createAsyncThunk(
  "eligibility/dealerCheck",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.dealerCheck(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const shareLink = createAsyncThunk(
  "eligibility/shareLink",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.shareLink(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const hyperverge = createAsyncThunk(
  "eligibility/hyperverge",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.hyperverge(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const hypervergecheck = createAsyncThunk(
  "eligibility/hypervergecheck",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.hypervergecheck(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const cKycCheck = createAsyncThunk(
  "eligibility/cKycCheck",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.cKycCheck(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const cKycOtpGenerate = createAsyncThunk(
  "eligibility/cKycOtpGenerate",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.cKycOtpGenerate(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const cKycOtpValidate = createAsyncThunk(
  "eligibility/cKycOtpValidate",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.cKycOtpValidate(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const fetchLeadDetails = createAsyncThunk(
  "eligibility/fetchLeadDetails",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.fetchLeadDetails(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const fetchLeadDataDetails = createAsyncThunk(
  "eligibility/fetchLeadDataDetails",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.fetchLeadDataDetails(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const fetchSfeData = createAsyncThunk(
  "eligibility/fetchSfeData",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.fetchSfeData(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const fetchRemarkData = createAsyncThunk(
  "eligibility/fetchRemarkData",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.fetchRemarkData(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const SubmitLead = createAsyncThunk(
  "eligibility/SubmitLead",
  async (data, thunkAPI) => {
    try {
      return await eligibilityService.SubmitLead(data);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

// No need to add extraReducers since you want to handle response directly in component


const eligibilitySlice = createSlice({
  name: 'eligibility',
  initialState,
  reducers: {
    setEligibiltyStep: (state, action) => {
      state.eligibiltyStep = action.payload;
    },
    setDealerCode: (state, action) => {
      state.dealerCode = action.payload;
    },
    setDealerData: (state, action) => {
      state.dealerData = action.payload;
    },
    setDealerType: (state, action) => {
      state.dealerType = action.payload;
    },
    setStage: (state, action) => {
      state.stage = action.payload;
    },
    setSubStage: (state, action) => {
      state.subStage = action.payload;
    },
    setKycLink: (state, action) => {
      state.kycLink = action.payload;
    },
    setImeiNumber: (state, action) => {
      state.imeiNumber = action.payload;
    },
    setProductCost: (state, action) => {
      state.productCost = action.payload;
    },
    setSelectedAddOns: (state, action) => {
      state.selectedAddOns = action.payload;
    },
    setUserAddOnDetails: (state, action) => {
      state.userAddOnDetails = action.payload;
    },
    setHdfcAddOnDetails: (state, action) => {
      state.hdfcAddOnDetails = action.payload;
    },
    setEligibilityLeads: (state, action) => {
      state.eligibilityLeads = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(kycStatusCheck.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(kycStatusCheck.fulfilled, (state, action) => {
        state.isLoading = false;
        // Handle successful response here if needed
      })
      .addCase(kycStatusCheck.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(productFetch.pending, (state) => {
        state.isLoading = true;
        state.data = [];
        state.error = null;
      })
      .addCase(productFetch.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload.response_data ?? [];
        // Handle successful response here if needed
      })
      .addCase(productFetch.rejected, (state, action) => {
        state.isLoading = false;
        state.data = [];
        state.error = action.payload;
      })
      .addCase(productCategoryFetch.pending, (state) => {
        state.isLoading = true;
        state.categoryData = [];
        state.error = null;
      })
      .addCase(productCategoryFetch.fulfilled, (state, action) => {
        state.isLoading = false;
        state.categoryData = action.payload.response_data ?? [];
        // Handle successful response here if needed
      })
      .addCase(productCategoryFetch.rejected, (state, action) => {
        state.isLoading = false;
        state.categoryData = [];
        state.error = action.payload;
      })
      .addCase(productVariantFetch.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(productVariantFetch.fulfilled, (state, action) => {
        const newPage = action.meta.arg.page || 1;
        const newData = action.payload.response_data ?? [];

        if (newPage > 1) {
          state.variantData = [...state.variantData, ...newData]; // Append
        } else {
          state.variantData = newData; // Replace
        }
      })
      .addCase(productVariantFetch.rejected, (state, action) => {
        state.isLoading = false;
        state.variantData = [];
        state.error = action.payload;
      })
      .addCase(productSearchVariantFetch.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(productSearchVariantFetch.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(skuSubmit.pending, (state) => {
        state.isLoading = true;
        state.schemeData = [];
        state.error = null;
      })
      .addCase(skuSubmit.fulfilled, (state, action) => {
        state.isLoading = false;
        state.schemeData = action.payload.response_data ?? [];
        // Handle successful response here if needed
      })
      .addCase(skuSubmit.rejected, (state, action) => {
        state.isLoading = false;
        state.schemeData = [];
        state.error = action.payload;
      })
      .addCase(selectedScheme.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(selectedScheme.fulfilled, (state, action) => {
        state.isLoading = false;
        state.summaryData = action.payload.response_data;
        // Handle successful response here if needed
      })
      .addCase(selectedScheme.rejected, (state, action) => {
        state.isLoading = false;
        state.summaryData = [];
        state.error = action.payload;
      })
      .addCase(dealerSelfie.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(dealerSelfie.fulfilled, (state, action) => {
        state.isLoading = false;
        // Handle successful response here if needed
      })
      .addCase(dealerSelfie.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(kycLink.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(kycLink.fulfilled, (state, action) => {
        state.isLoading = false;
        state.kycLink = action.payload.response_data?.url;
        // Handle successful response here if needed
      })
      .addCase(kycLink.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(getApplicationData.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getApplicationData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.allDetails = action.payload; // Store in separate field
        // Also update dashboardDetails for backward compatibility
        state.applicationDetail = action.payload?.response_data;
        //state.referenceId = action.payload?.response_data?.reference_id
        state.stage = action.payload?.response_data?.stage;
        state.subStage = action.payload?.response_data?.sub_stage;
        state.schemeData = action.payload?.response_data?.scheme_detail;
        state.imeiNumber = action.payload?.response_data?.imei_number
        state.productCost = action.payload?.response_data?.product_cost
        state.grade = action.payload?.response_data?.category
        state.customerName = action.payload?.response_data?.name
        state.emiData = action.payload?.response_data?.do_summary
        if (action.payload?.response_data?.stage === 'kyc') {
          state.kycLink = action.payload?.response_data?.url
        }
      })
      .addCase(getApplicationData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(emiDetails.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(emiDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload?.response_data && action.payload.response_code === 'S100') {
          state.summaryData = action.payload.response_data;
        }
        // Handle successful response here if needed
      })
      .addCase(emiDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.summaryData = [];
        state.error = action.payload;
      })
      .addCase(addOnDetails.pending, (state) => {
        state.isLoading = true;
        state.addOnData = [];
        state.error = null;
      })
      .addCase(addOnDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        state.addOnData = action.payload.response_data ?? [];
        // Handle successful response here if needed
      })
      .addCase(addOnDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.addOnData = [];
        state.error = action.payload;
      })
      .addCase(addOnSubmit.pending, (state) => {
        state.isLoading = true;
        state.emiData = [];
        state.error = null;
      })
      .addCase(addOnSubmit.fulfilled, (state, action) => {
        state.isLoading = false;
        state.emiData = action.payload.response_data?.do_summary ?? [];
        // Handle successful response here if needed
      })
      .addCase(addOnSubmit.rejected, (state, action) => {
        state.isLoading = false;
        state.emiData = [];
        state.error = action.payload;
      })
      .addCase(productDetails.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(productDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        state.productDetailsData = action.payload;
      })
      .addCase(productDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(etbSummary.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(etbSummary.fulfilled, (state, action) => {
        state.isLoading = false;
        state.etbData = action.payload.response_data;
      })
      .addCase(etbSummary.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(editedKycSubmit.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(editedKycSubmit.fulfilled, (state, action) => {
        state.isLoading = false;
        state.kycLink = action.payload.response_data?.url;
      })
      .addCase(editedKycSubmit.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchLeadDataDetails.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchLeadDataDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        state.leadData = action.payload.response_data;
      })
      .addCase(fetchLeadDataDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
  },
});

export const {
  setEligibiltyStep,
  setDealerCode,
  setDealerData,
  setDealerType,
  setStage,
  setSubStage,
  setKycLink,
  setImeiNumber,
  setProductCost,
  setSelectedAddOns,
  setUserAddOnDetails,
  setHdfcAddOnDetails,
  setEligibilityLeads
} = eligibilitySlice.actions;

export default eligibilitySlice.reducer;